export const blogs = [
    {
        "id":"sdet",
        "title":"How to be SDET",
        "url":"https://planet-frost-acd.notion.site/Alejandro-Cabrera-SDET-Portfolio-56e39140b78f45f8888d6f1ec876c720",
        "description":"I am giving some advices about how to be tester in the software development life cycle",
    },{
        "id":"university",
        "title":"Go to the University",
        "url":"https://dev.to/alcabrera/3-reasons-why-you-should-go-to-the-university-instead-of-learn-by-yourself-45af",
        "description":"I am talking about the difference between somebody that go to the university and somebody that doesn't inside the programming field"
    }

]